import React from 'react';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import BackdropWithLoader from '../../../../../Tools/BackdropWithLoader/BackdropWithLoader';
import BatchErrorModal from '../../BatchErrorModal';
import ToAssignPanel from './ToAssignPanel';
import TechnicianPanel from './TechnicianPanel';
import { useAssignmentTransition } from './useAssignmentTransition';

export default function AssignmentStep() {
  const { t } = useTranslation();
  // L'envoi se déclenche à droite, le renvoi dans le pied de table à gauche, et le
  // bilan s'affiche à gauche : l'état vit donc au-dessus des deux colonnes.
  const transitionState = useAssignmentTransition();

  const loaderKey =
    transitionState.runningTransition === 'sendBack'
      ? 'interventionCreation.assignment.sendingBack'
      : 'interventionCreation.assignment.sending';

  return (
    <>
      <BackdropWithLoader open={transitionState.isRunning} message={t(loaderKey)} />

      <BatchErrorModal
        open={transitionState.hasFailed}
        message={t('interventionCreation.assignment.sendError')}
        reason={transitionState.failureReason}
        onClose={transitionState.dismiss}
      />

      <Grid container spacing={2} alignItems="flex-start">
        <Grid item xs={12} lg={8}>
          <ToAssignPanel transitionState={transitionState} />
        </Grid>
        <Grid item xs={12} lg={4}>
          <TechnicianPanel transitionState={transitionState} />
        </Grid>
      </Grid>
    </>
  );
}
